import { Controller } from "@hotwired/stimulus"
import { getMetaValue } from "../plugins/src/metadata"

// Toggle a textarea between Write (the textarea itself) and Preview
// (server-rendered HTML via POST /markdown_preview). Server-rendered so
// the preview is byte-identical to what readers will see published.
export default class extends Controller {
  static targets = ["textarea", "preview", "writeTab", "previewTab"]
  static values = { previewUrl: String }

  connect() {
    this.showWrite()
  }

  showWrite() {
    this.textareaTarget.classList.remove("hidden")
    this.previewTarget.classList.add("hidden")
    this._activate(this.writeTabTarget, this.previewTabTarget)
  }

  async showPreview() {
    this._activate(this.previewTabTarget, this.writeTabTarget)
    this.textareaTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")

    const text = this.textareaTarget.value
    if (text.trim() === "") {
      this._setPreview("empty", '<p class="text-sm text-gray-500 italic">Nothing to preview yet.</p>')
      return
    }

    this._setPreview("loading", '<p class="text-sm text-gray-500 italic" role="status">Loading preview…</p>')

    try {
      const body = new URLSearchParams()
      body.append("text", text)

      const response = await fetch(this.previewUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": getMetaValue("csrf-token"),
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/html"
        },
        body: body.toString(),
        credentials: "same-origin"
      })

      if (!response.ok) {
        this._setPreview("error", '<p class="text-sm text-red-600">Couldn\'t load preview.</p>')
        return
      }

      this._setPreview("rendered", await response.text())
    } catch (e) {
      this._setPreview("error", '<p class="text-sm text-red-600">Couldn\'t load preview.</p>')
    }
  }

  _setPreview(state, html) {
    this.previewTarget.dataset.state = state
    this.previewTarget.innerHTML = html
  }

  _activate(activeTab, inactiveTab) {
    activeTab.classList.add("bg-gray-100", "dark:bg-gray-700", "text-gray-900", "dark:text-white")
    activeTab.classList.remove("text-gray-500")
    activeTab.setAttribute("aria-pressed", "true")

    inactiveTab.classList.remove("bg-gray-100", "dark:bg-gray-700", "text-gray-900", "dark:text-white")
    inactiveTab.classList.add("text-gray-500")
    inactiveTab.setAttribute("aria-pressed", "false")
  }
}
